<template>
  <div class="container">
    <div class="word_split wrapper animate__animated animate__fadeInDown">
      <span class="word word1"> Xiao </span>
      <span class="word word2"> Qi </span>
      <span class="word word3">Personal</span>
      <span class="word word4">Details</span>
      <span class="word word5">Employment</span>
      <span class="word word6">Hobby </span>
      <span class="word word7">&nbsp;</span>
      <span class="word word8">Technical</span>
      <span class="word word9">Skills </span>
      <span class="word word10">Personal</span>
      <span class="word word11">Target </span>
      <span class="word word12">Get In </span>
      <span class="word word13">Touch</span>
      <span class="word word13">&nbsp;</span>
      <span class="word word13">&nbsp;</span>
      <span class="word word13">&nbsp;</span>
      <span class="word word13">&nbsp;</span>
      <div class="bubble1">
        <span class="the-arrow1"></span>
        HI! <br/> I AM..
      </div>
      <div class="bubble2">
        <span class="the-arrow2"></span>
        <img class="bub-img" src="../../assets/icon/logo.png"/>
      </div>
      <div class="bubble3">
        <span class="the-arrow3"></span>
        一个很菜的佳哇程序猿...<br/><br/>
        一个非常菜的前端工程狮...<br/><br/>
        一个真的略懂的全栈开发者...<br/>
      </div>
      <div class="bubble4">
        <span class="the-arrow4"></span>
        目前从事于制造业.<br/>
        略懂一些MES系统相关的东西...<br/>
        而且擅长解决一些MES相关的问题...<br/>
        当然什么ERP啦PLM啦WMS啦OA啦LMS啦都是略懂..<br/><br/>
        这是真的..
      </div>
      <div class="bubble5">
        <span class="the-arrow5"></span>
        爱好嘛..<br/>
        胡乱跑,啊啊啊~~比赛什么的,氛围老好啦!♪(^∇^*)<br/>
        还有吃,标准吃货一枚!<br/>
        当然,<br/>
        还有什么比电子游戏更吸引IT小伙伴的吗?<br/>
        可惜现在只能与生活对线了...呜呜

      </div>
      <div class="bubble6">
        <span class="the-arrow6"></span>
        JAVA 比较一般<br/>
        VUE 略懂<br/>
        数据库 皮毛<br/>
        服务器 可以瞎鼓捣一下<br/>
        能力 擅长面向百度编程...<br/><br/>
        0.0总之就是一般、略懂、马马虎虎、凑凑合合...<br/>
      </div>
      <div class="bubble7">
        <span class="the-arrow7"></span>
        目前的梦想...<br/>
        走遍三山五岳!<br/>
        去一次拉萨!<br/>
        跑一次马拉松!<br/>
        完成一次百公里越野!<br/><br/>

        目前最远跑步距离:42Km<br/>
      </div>
      <div class="bubble8">
        <span class="the-arrow8"></span>
        如果你要问我为什么喜欢长跑...<br/>
        据说...<br/>
        喜欢长跑的人... <br/>
        脑袋瓜儿可能都不太正常...<br/>
        当然...<br/>
        也可能是吃饱了撑的...<br/>
        狗头保命 QAQ
      </div>
    </div>

  </div><!--end container-->

</template>

<script>
export default {
  name: "aboutMeNew"
}
</script>

<style scoped>

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  /* The old syntax, deprecated, but still needed, prefixed, for WebKit-based and old browsers */
  background: linear-gradient(left, #E7E7E7, white, #E7E7E7);
  /* The new syntax needed by standard-compliant browsers (Opera 12.1, IE 10, Fx 16 onwards), without prefix */
  background: linear-gradient(to right, #E7E7E7, white, #E7E7E7);
}

.container {
  width: 100%;
  /*height: 100%;*/
  overflow: hidden;
}

.wrapper {
  width: 270px;
  margin: 50px auto;
  position: Relative;
}

.word {
  display: block;
  text-align: justify;
  font-family: "BenchNine";
  line-height: 0.8;
  text-transform: uppercase;
  letter-spacing: 0;
  word-wrap: break-word;
  word-break: normal;
  font-size: 3em
}

.word1, .word2 {
  color: #9BC5DE;
}

.word3 {
  color: #90B3C9;
  margin-top: 60px;
}

.word4 {
  color: #90B3C9;
}

.word5 {
  color: #809BB0;
  margin-top: 60px;
}

.word6 {
  color: #809BB0
}

.word7 {
  color: #6B7B8A
}

.word8 {
  color: #8B8091;
  margin-top: 60px;
}

.word9 {
  color: #8B8091
}

.word10 {
  color: #B68FA2;
  margin-top: 60px;
}

.word11 {
  color: #B68FA2
}

.word12 {
  color: #D99AB5;
  margin-top: 60px;
}

.word13 {
  color: #D99AB5
}


.bubble1 {
  width: 75px;
  height: 70px;
  background-color: #99C5DE;
  color: white;
  position: absolute;

  border-radius: 0 20px 0 20px;

  top: 0;
  left: -100px;
  padding: 10px;
  font-size: 1em;
  line-height: 1;
}

span.the-arrow1 {
  display: inline-block;
  width: 0;
  height: 0;

  border-left: 12px solid;
  border-right: 0 #99C5DE;
  border-bottom: 12px #99C5DE;
  position: absolute;

  top: 63px;
  left: 75px;

  transform: rotateY(180deg);
}


.bubble2 {
  width: 180px;
  height: 180px;
  background-color: #99C5DE;
  color: white;
  position: absolute;

  border-radius: 30px 0 30px 0;

  left: 290px;
  top: 20px;

  padding: 20px;
  font-size: 1em;
  line-height: 1;

}

span.the-arrow2 {
  display: inline-block;
  width: 0;
  height: 0;

  border-left: 20px solid;
  border-right: 0 #99C5DE;
  border-bottom: 20px #99C5DE;
  position: absolute;

  top: 130px;
  left: -19px;
}

.bub-img {
  background: white;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}

.bubble3 {
  width: 170px;
  height: 200px;
  padding: 20px;
  color: white;
  background-color: #90B2CB;
  position: absolute;
  border-radius: 0 30px 0 30px;

  top: 100px;
  left: -195px;

}

span.the-arrow3 {
  display: inline-block;
  width: 0;
  height: 0;

  border-left: 20px solid;
  border-right: 0 #99C5DE;
  border-bottom: 20px #99C5DE;
  position: absolute;

  top: 0;
  left: 250px;
  transform: rotateY(180deg);
}


.bubble4 {
  width: 220px;
  height: 240px;
  padding: 20px;
  color: white;
  background-color: #809BAE;
  position: absolute;
  border-radius: 0 30px 0 30px;

  top: 240px;
  left: 290px;
}

span.the-arrow4 {
  display: inline-block;
  width: 0;
  height: 0;

  border-left: 20px solid;
  border-right: 0 #99C5DE;
  border-bottom: 20px #99C5DE;
  position: absolute;

  top: 160px;
  left: -19px;
}


.bubble5 {
  width: 200px;
  height: 260px;
  padding: 20px;
  color: white;
  background-color: #697A8A;
  position: absolute;
  border-radius: 0 30px 0 30px;

  top: 340px;
  left: -225px;
}

span.the-arrow5 {
  display: inline-block;
  width: 0;
  height: 0;

  border-left: 20px solid;
  border-right: 0 #99C5DE;
  border-bottom: 20px #99C5DE;
  position: absolute;

  top: 0;
  left: 250px;
  transform: rotateY(180deg);
}


.bubble6 {
  width: 220px;
  height: 240px;
  padding: 20px;
  color: white;
  background-color: #8B8091;
  position: absolute;
  border-radius: 0 30px 0 30px;

  top: 520px;
  left: 290px;
}

span.the-arrow6 {
  display: inline-block;
  width: 0;
  height: 0;

  border-left: 20px solid;
  border-right: 0 #99C5DE;
  border-bottom: 20px #99C5DE;
  position: absolute;

  top: 160px;
  left: -19px;
}


.bubble7 {
  width: 200px;
  height: 200px;
  padding: 20px;
  color: white;
  background-color: #B68EA6;
  position: absolute;
  border-radius: 0 30px 0 30px;

  top: 640px;
  left: -225px;
}

span.the-arrow7 {
  display: inline-block;
  width: 0;
  height: 0;

  border-left: 20px solid;
  border-right: 0 #99C5DE;
  border-bottom: 20px #99C5DE;
  position: absolute;

  top: 0;
  left: 250px;
  transform: rotateY(180deg);
}


.bubble8 {
  width: 220px;
  height: 240px;
  padding: 20px;
  color: white;
  background-color: #D99AB5;
  position: absolute;
  border-radius: 0 30px 0 30px;

  top: 800px;
  left: 290px;
}

span.the-arrow8 {
  display: inline-block;
  width: 0;
  height: 0;

  border-left: 20px solid;
  border-right: 0 #99C5DE;
  border-bottom: 20px #99C5DE;
  position: absolute;

  top: 160px;
  left: -19px;
}

</style>